import Metric from './metric.js';

export default class DisplayMetric extends Metric {
  static name = 'content_display';

  constructor(event) {
    if (import.meta.env.DEV) {
      console.assert(event.metrics.length > 0, 'Metrics should not be empty');
      console.assert(
        event.metrics.length >= 4,
        'Metrics should have at last 4 states',
      );
      console.assert(
        event.metrics[0][0] === 'content requested',
        'First state should be "content requested"',
      );
      console.assert(
        event.metrics[event.metrics.length - 1][0] === 'display',
        'Last state should be "display"',
      );

      console.info(
        `Create new metric: ${DisplayMetric.name}, entityId: ${event.interactive_id}`,
        event.metrics
          .map(([state, time]) => [state, time - event.metrics[0][1]]) // rebase times to first state
          .filter((_, i) => i > 0), // only non-zero interval
        // .map(([, time]) => time) // only time
      );
    }

    const payload = Object.fromEntries(event.metrics.reduceRight((acc, [state, time], index) => {
      if (acc.length === 0) {
        return [[state, time]];
      }

      acc[0][1] = acc[0][1] - time;

      if (index > 0) {
        acc.unshift([state, time]);
      }

      return acc;
    }, []));

    super(event.interactive_id, {
      interactive_type: event.creative.promoCreativeType,
      payload,
    });
  }
}
